module.exports = __webpack_public_path__ + "img/2.425310cb.png";